// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout'

const platformRouter = {
  path: '/platform',
  component: Layout,
  redirect: '/contract/contractFiles',
  name: 'latform',
  alwaysShow: true,
  meta: {
    title: '平台管理',
    icon: 'clipboard'
  },
  children: [
    {
      path: 'contractFiles',
      component: () => import('@/views/contract/contractFiles'),
      name: 'ContractIndex',
      meta: { title: '合同模板管理' }
    },
    {
      path: 'difyConfigList',
      component: () => import('@/views/difyConfig/difyConfigList'),
      name: 'DifyConfigList',
      meta: { title: '智能体管理' }
    },
    {
      path: 'difyDesign',
      component: () => import('@/views/difyConfig/difyDesign'),
      name: 'DifyDesign',
      meta: { title: '智能体表单设计' }
    },
    {
      path: 'difySession',
      component: () => import('@/views/difySession/difySessionList'),
      name: 'DifySession',
      meta: { title: '会话管理' }
    },
    {
      path: 'grade',
      component: () => import('@/views/user/grade/index'),
      name: 'Grade',
      meta: { title: '会员管理', icon: '' }
    }
    ,
    {
      path: 'setting',
      component: () => import('@/views/appSetting/miniSetting/index'),
      name: 'Setting',
      meta: { title: '小程序设置', icon: '' }
    },
    {
      path: 'chatMessage',
      component: () => import('@/views/chatMessage/chatMessage'),
      name: 'ChatMessage',
      meta: { title: '会话追溯' }
    },
    {
      path: 'agentInvoke',
      component: () => import('@/views/agentInvoke/diligence/index'),
      name: 'AgentInvokeDiligence',
      meta: { title: '尽职调查', perms: 'admin:agentInvoke:diligence:list' }
    },
    {
      path: 'agentInvokeLetter',
      component: () => import('@/views/agentInvoke/letter/index'),
      name: 'AgentInvokeLetter',
      meta: { title: '律师函', perms: 'admin:agentInvoke:letter:list' }
    },
  ]
}

export default platformRouter
